"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT = exports.QUESTIONS = exports.PAGES = exports.ANSWERS = void 0;
var _react = _interopRequireDefault(require("react"));
var PAGES = exports.PAGES = {
  TITLE: 0,
  DESCRIPTION: 1,
  QUESTION_1: 2,
  QUESTION_2: 3,
  QUESTION_3: 4,
  QUESTION_4: 5,
  QUESTION_5: 6,
  SUMMARY: 7,
  FINAL: 8
};
var QUESTIONS = exports.QUESTIONS = [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "1. On average, during the past week, how often were you", ' ', /*#__PURE__*/_react["default"].createElement("strong", null, "woken by your asthma"), " during the night?"), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "2. On average, during the past week, how", ' ', /*#__PURE__*/_react["default"].createElement("strong", null, "bad were your asthma symptoms when you woke up"), " in the morning?"), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "3. In general, during the past week, how", ' ', /*#__PURE__*/_react["default"].createElement("strong", null, "limited were you in your activities"), " because of your asthma?"), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "4. In general, during the past week, how much", ' ', /*#__PURE__*/_react["default"].createElement("strong", null, "shortness of breath"), " did you experience because of your asthma?"), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "5. In general, during the past week, how much of the time did you", ' ', /*#__PURE__*/_react["default"].createElement("strong", null, "wheeze"), "?")];
var ANSWERS = exports.ANSWERS = [['0 - Never', '1 - Hardly ever', '2 - A few times', '3 - Several times', '4 - Many times', '5 - A great many times', '6 - Unable to sleep because of asthma'], ['0 - No symptoms', '1 - Very mild symptoms', '2 - Mild symptoms', '3 - Moderate symptoms', '4 - Quite severe symptoms', '5 - Severe symptoms', '6 - Very severe symptoms'], ['0 - Not limited at all', '1 - Very slightly limited', '2 - Slightly limited', '3 - Moderately limited', '4 - Very limited', '5 - Extremely limited', '6 - Totally limited'], ['0 - None', '1 - A very little', '2 - A little', '3 - A moderate amount', '4 - Quite a lot', '5 - A great deal', '6 - A very great deal'], ['0 - Not at all', '1 - Hardly any of the time', '2 - A little of the time', '3 - A moderate amount of the time', '4 - A lot of the time', '5 - Most of the time', '6 - All the time']];
var TEXT = exports.TEXT = {
  titlePage: {
    title: 'Asthma Control Questionnaire (ACQ) (Symptoms Only)',
    subtitle: 'ENGLISH VERSION FOR NORTH AMERICA',
    copyright: 'The Asthma Control Questionnaire (ACQ) is copyrighted and all rights are reserved. No part of this questionnaire may be sold, modified or reproduced in any form without the express permission of Elizabeth Juniper on behalf of QOL Technologies Limited.'
  },
  descriptionPage: {
    title: 'Please answer questions 1-5.',
    description: {
      select: 'Select',
      instruction: 'the response that best describes how you have been during the past week.'
    }
  },
  summaryPage: {
    title: 'Please review your answers',
    subtitle: 'Click on an answer to change your selection'
  },
  finalPage: {
    title: 'For any information on the use of electronic ACQ, please contact Mapi Research Trust, Lyon, France.',
    internet: 'Internet: '
  },
  buttons: {
    back: 'Back',
    next: 'Next'
  },
  copyrightBanner: 'ACQ©2002 QOL TECHNOLOGIES LTD.'
};